












































































import 'reflect-metadata'
import { Mixins, Component } from 'vue-property-decorator'
import ValidatorRow from '@/components/rows/ValidatorRow/ValidatorRow.vue'
import ValidatorPaginationControls from '@/components/misc/ValidatorPaginationControls.vue'
import { AVALANCHE_SUBNET_ID } from '@/store/modules/platform/platform'
import Tooltip from '@/components/rows/Tooltip.vue'
import Metadata from '@/components/Validators/Metadata.vue'
import StakingMetadata from '@/components/Validators/StakingMetadata.vue'
import { IValidator } from '@/store/modules/platform/IValidator'
import { PlatformGettersMixin } from '@/store/modules/platform/platform.mixins'
import { bigToDenomBig } from '@/helper'

@Component({
    components: {
        Tooltip,
        ValidatorRow,
        ValidatorPaginationControls,
        Metadata,
        StakingMetadata,
    },
})
export default class Validators extends Mixins(PlatformGettersMixin) {
    search = ''
    toggle = 'active' // active | pending
    limit = 25 // how many rows to display
    start = 0

    matchSearch(val: HTMLInputElement) {
        if (this.search) {
            const idUpper = val.id.toUpperCase()
            const queryUpper = this.search.toUpperCase()
            if (!idUpper.includes(queryUpper)) {
                return false
            }
        }
        return true
    }

    handleChange(val: number) {
        this.start = val // all computed values will react to change
    }

    handleToggle(val: string) {
        this.toggle = val
    }

    get totalStake() {
        let valBig =
            this.toggle === 'active'
                ? this.getTotalStake()
                : this.getTotalPendingStake()
        valBig = bigToDenomBig(valBig, 9)
        return valBig.toLocaleString(0)
    }

    get totalValidatorsCount() {
        return this.toggle === 'active'
            ? this.getTotalValidators()
            : this.getTotalPendingValidators()
    }

    get validators() {
        const defaultSubnet = this.$store.state.Platform.subnets[
            AVALANCHE_SUBNET_ID
        ]
        if (defaultSubnet) {
            return this.toggle === 'active'
                ? defaultSubnet.validators
                : defaultSubnet.pendingValidators
        }
        return []
    }

    get matchedValidators() {
        return this.validators
            .filter((v: IValidator) => v.nodeID.includes(this.search))
            .slice(0, 10)
    }

    get paginatedValidators() {
        return this.validators.slice(this.start, this.start + this.limit)
    }

    get pendingValidators() {
        const defaultSubnet = this.$store.state.Platform.subnets[
            AVALANCHE_SUBNET_ID
        ]
        if (defaultSubnet) {
            const vals = defaultSubnet.pendingValidators
            return vals
        }
        return []
    }

    get cumulativeStake() {
        const defaultSubnet = this.$store.state.Platform.subnets[
            AVALANCHE_SUBNET_ID
        ]
        if (defaultSubnet) {
            return this.toggle === 'active'
                ? this.getCumulativeStake()
                : this.getCumulativePendingStake()
        }
        return []
    }
}
